<template lang="pug">
  .solution-block
    p {{question.question}}
    p.as-answer {{question.answer|fixdecimal}}
    p(
      v-for="choice in question.choices"
      v-if="choice != question.answer"
      :class="(question.selectedAnswer == choice) ? 'as-error': ''"
    ) {{choice|fixdecimal}}
</template>

<script type="text/javascript">
import utils from "@/service/utils";

export default {
  name: "QuestionErrorBlock",
  props: ["question"],
  filters: {
    fixdecimal: function (value) {
      return utils.fixdecimal(value);
    },
  },
};
</script>
